import { render, staticRenderFns } from "./ModalUpdate.vue?vue&type=template&id=1a870324&scoped=true"
import script from "./ModalUpdate.vue?vue&type=script&lang=js"
export * from "./ModalUpdate.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdate.vue?vue&type=style&index=0&id=1a870324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a870324",
  null
  
)

export default component.exports